export const getPageIdSelector = (state) => state.getIn(['app', 'session', 'pageId']);
